import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-geom',
  templateUrl: './geom.component.html',
  styleUrls: ['./geom.component.scss']
})
export class GeomComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
